import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TdoTableSelectionEvent } from '../../tdo-table-v2/models/tdo-table-selection.event';

@Component({
  selector: 'app-tdo-select-dialog',
  templateUrl: './tdo-select-dialog.component.html',
  styleUrls: ['./tdo-select-dialog.component.scss']
})
export class TdoSelectDialogComponent implements OnInit{

  items: any[] = [];
  isSearchable: boolean = false;
  tableTitle: string = '';
  columnDefinitions: any[] = [];
  selectedItem: any;
  constructor(public dialogRef: MatDialogRef<TdoSelectDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      ) { }
  
    ngOnInit(): void {
      console.log("TdoSelectDialogComponent ngOnInit: ", this.data);
      if (this.data) {
        this.tableTitle = this.data.tableTitle;
        this.items = this.data.dataSource;
        this.isSearchable = this.data.isSearchable;
        this.columnDefinitions = this.data.columnDefinitions;
      }
    }

    onCancelClick() {
      console.log("TdoSelectDialogComponent onCancelClick");
      this.dialogRef.close();
    }

    onOkClick() {
      console.log("TdoSelectDialogComponent onOkClick: ", this.selectedItem);

      this.dialogRef.close(this.selectedItem);
    }

      onRowSelected($event: TdoTableSelectionEvent) {
        console.log("TdoSelectDialogComponent onRowSelected: ", $event);
        this.selectedItem = $event.model;
      }
}
